import React, { useCallback, useEffect, useRef, useState } from 'react'

import DataContextProvider from './DataContext'
import Panel from '../../../elem/panel/Panel'
import { aggregatePanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import BoxPlotHeader from './BoxPlotHeader'
import BoxPlotWrapper from './BoxPlotWrapper'

const BoxPlot = ({ width }) => {
    const ref = useRef(null)
    const [isCollapsed, setCollapsed] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false)
    const [displayFilterModeDropdown, setDisplayFilterModeDropdown] = useState(
        false
    )

    return (
        <Panel panelClassConfig={panelClassConfig(width)}>
            <div
                ref={ref}
                className={`explorerWrapper ${
                    isExpanded ? `fullscreen-overlay` : ``
                }`}
            >
                <DataContextProvider>
                    <BoxPlotHeader
                        isCollapsed={isCollapsed}
                        setCollapsed={setCollapsed}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                        displayFilterModeDropdown={displayFilterModeDropdown}
                        setDisplayFilterModeDropdown={
                            setDisplayFilterModeDropdown
                        }
                    />
                    <BoxPlotWrapper
                        containerRef={ref}
                        isCollapsed={isCollapsed}
                        setCollapsed={setCollapsed}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                        displayFilterModeDropdown={displayFilterModeDropdown}
                        setDisplayFilterModeDropdown={
                            setDisplayFilterModeDropdown
                        }
                    />
                </DataContextProvider>
            </div>
        </Panel>
    )
}

export default BoxPlot
